import { useRef, useState, useEffect } from "react";
import { 
  FaBars, 
  FaTimes, 
  FaUser, 
  FaSignOutAlt, 
  FaHeart, 
  FaSearch, 
  FaCrown,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaFacebookF,
  FaInstagram,
  FaYoutube
} from "react-icons/fa";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./Navbar.css";
import { useAuth } from "../../../AuthContext";
import Logo from "../rgt-matrimony-logo.png";

function Navbar({ userid }) {
  const navRef = useRef();
  const { isLoggedIn, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Check if current page is registration page
  const isRegistrationPage = location.pathname === "/Freereg" || location.pathname === "/freereg";

  // Handle scroll effect - DISABLE on registration page
  useEffect(() => {
    // Don't apply scroll effect on registration page
    if (isRegistrationPage) {
      setScrolled(false);
      return;
    }

    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isRegistrationPage]);

  const showNavbar = () => {
    navRef.current.classList.toggle("tlr-nav-responsive");
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeNavbar = () => {
    navRef.current.classList.remove("tlr-nav-responsive");
    setMobileMenuOpen(false);
  };

  const handleLogout = () => {
    logout();
    closeNavbar();
    navigate("/");
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <>
      {/* Premium Top Bar - Hide on registration page if needed */}
      {!isRegistrationPage && (
        <div className={`tlr-top-bar ${scrolled ? "tlr-top-bar-hidden" : ""}`}>
          <div className="tlr-top-bar-container">
            <div className="tlr-top-bar-left">
              <div className="tlr-info-item">
                <div className="tlr-info-icon">
                  <FaPhoneAlt />
                </div>
                <span>+91 9443052440</span>
              </div>
              <div className="tlr-info-divider"></div>
              <div className="tlr-info-item">
                <div className="tlr-info-icon">
                  <FaMapMarkerAlt />
                </div>
                <span>எட்டயபுரம் வளைவு ரோடு, கோவில்பட்டி - 628501</span>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Main Navbar - Remove sticky on registration page */}
      <header className={`tlr-main-header ${scrolled && !isRegistrationPage ? "tlr-header-scrolled" : ""} ${isRegistrationPage ? "tlr-header-static" : ""}`}>
        <div className="tlr-header-container">
          {/* Logo Section */}
          <Link to="/" className="tlr-logo" onClick={closeNavbar}>
            <div className="tlr-logo-wrapper">
              <img src={Logo} className="tlr-navbar-logo" alt="Tulir Matrimony" />
              <div className="tlr-logo-shine"></div>
            </div>
          </Link>

          {/* Navigation Menu */}
          <nav ref={navRef} className={`tlr-nav ${mobileMenuOpen ? "tlr-nav-mobile-open" : ""}`}>
            <button className="tlr-nav-close-btn" onClick={showNavbar}>
              <FaTimes />
            </button>
            
            <ul className="tlr-nav-menu">
              {isLoggedIn ? (
                <>
                  <li className="tlr-nav-item">
                    <Link 
                      to="/Searchlist" 
                      className={`tlr-nav-link ${isActive("/Searchlist") ? "tlr-active" : ""}`} 
                      onClick={closeNavbar}
                    >
                      <FaHeart className="tlr-nav-icon" />
                      <span>Home</span>
                      <div className="tlr-nav-glow"></div>
                    </Link>
                  </li>
                  <li className="tlr-nav-item">
                    <Link 
                      to="/Profile" 
                      className={`tlr-nav-link ${isActive("/Profile") ? "tlr-active" : ""}`} 
                      onClick={closeNavbar}
                    >
                      <FaUser className="tlr-nav-icon" />
                      <span>Profile</span>
                      <div className="tlr-nav-glow"></div>
                    </Link>
                  </li>
                  <li className="tlr-nav-item">
                    <Link 
                      to="/Selectedplan" 
                      className={`tlr-nav-link ${isActive("/Selectedplan") ? "tlr-active" : ""}`} 
                      onClick={closeNavbar}
                    >
                      <FaCrown className="tlr-nav-icon" />
                      <span>Plan Details</span>
                      <div className="tlr-nav-glow"></div>
                    </Link>
                  </li>
                  <li className="tlr-nav-item">
                    <Link 
                      to="/Searchform" 
                      className={`tlr-nav-link ${isActive("/Searchform") ? "tlr-active" : ""}`} 
                      onClick={closeNavbar}
                    >
                      <FaSearch className="tlr-nav-icon" />
                      <span>Search</span>
                      <div className="tlr-nav-glow"></div>
                    </Link>
                  </li>
                </>
              ) : (
                <>
                  <li className="tlr-nav-item">
                    <Link 
                      to="/" 
                      className={`tlr-nav-link ${isActive("/") ? "tlr-active" : ""}`} 
                      onClick={closeNavbar}
                    >
                      <span>Home</span>
                      <div className="tlr-nav-glow"></div>
                    </Link>
                  </li>
                  <li className="tlr-nav-item">
                    <Link 
                      to="/Plans" 
                      className={`tlr-nav-link ${isActive("/Plans") ? "tlr-active" : ""}`} 
                      onClick={closeNavbar}
                    >
                      <FaCrown className="tlr-nav-icon" />
                      <span>Membership Plans</span>
                      <div className="tlr-nav-glow"></div>
                    </Link>
                  </li>
                </>
              )}
            </ul>

            {/* Auth Buttons - Premium Design */}
            <div className="tlr-auth-buttons">
              {isLoggedIn ? (
                <button className="tlr-btn-logout" onClick={handleLogout}>
                  <FaSignOutAlt />
                  <span>Logout</span>
                  <div className="tlr-btn-shine"></div>
                </button>
              ) : (
                <>
                  <Link to="/Login" className="tlr-btn-login" onClick={closeNavbar}>
                    <FaUser />
                    <span>Sign In</span>
                    <div className="tlr-btn-shine"></div>
                  </Link>
                  <Link to="/Freereg" className="tlr-btn-register" onClick={closeNavbar}>
                    <span>Register</span>
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <path d="M5 12H19M19 12L13 6M19 12L13 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                    <div className="tlr-btn-shine"></div>
                  </Link>
                </>
              )}
            </div>
          </nav>

          {/* Mobile Menu Button */}
          <button className="tlr-mobile-menu-btn" onClick={showNavbar}>
            <FaBars />
          </button>
        </div>
      </header>
    </>
  );
}

export default Navbar;